const PRODUCTION_IMAGE_BASE = 'https://braxohub.com/images';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');

const getMenuImageBaseUrl = (): string => {
  const configuredImageBaseUrl = trimTrailingSlashes(process.env.REACT_APP_IMAGE_URL || '');
  if (configuredImageBaseUrl) {
    return configuredImageBaseUrl;
  }

  const menuApiUrl = trimTrailingSlashes(process.env.REACT_APP_MENU_API_URL || '');
  if (menuApiUrl) {
    const menuApiOrigin = menuApiUrl.replace(/\/api$/i, '');
    return `${menuApiOrigin}/images`;
  }

  return PRODUCTION_IMAGE_BASE;
};

const hostOf = (url: string): string => {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return '';
  }
};

// Hosts whose /images and /uploads paths are our own menu images and may be rebased.
const isManagedImageHost = (hostname: string): boolean => {
  if (!hostname) return false;
  const known = [
    hostOf(PRODUCTION_IMAGE_BASE),
    hostOf(process.env.REACT_APP_IMAGE_URL || ''),
    hostOf(process.env.REACT_APP_MENU_API_URL || ''),
  ].filter(Boolean);
  return known.includes(hostname) || hostname.endsWith('.braxohub.com') || hostname === 'localhost';
};

export const getMenuImageUrl = (imagePath?: string | null): string => {
  if (!imagePath) return '';

  const cleanPath = imagePath.trim();
  const imageBaseUrl = getMenuImageBaseUrl();

  // Rebase stored menu-image URLs onto the configured menu image host, but only for our own hosts
  // so an image hosted elsewhere is left untouched.
  if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://')) {
    try {
      const parsedUrl = new URL(cleanPath);
      const managedImagePath = parsedUrl.pathname.match(/^\/(?:images|uploads)\/([^/]+)$/i);
      if (managedImagePath && isManagedImageHost(parsedUrl.hostname.toLowerCase())) {
        return `${imageBaseUrl}/${managedImagePath[1]}`;
      }
      return cleanPath;
    } catch {
      return cleanPath;
    }
  }

  // Extract just the filename, stripping any leading path segments
  // Handles: /images/foo.png  |  /uploads/foo.png  |  foo.png
  const filename = cleanPath.split('?')[0].split('#')[0].split('/').filter(Boolean).pop();

  return filename ? `${imageBaseUrl}/${filename}` : '';
};
